import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { SummaryAPI } from "../../../../../../RemoteAPI/Summary";
import PennyPincherSpinner from "../../../../../PennyPincherSpinner/PennyPincherSpinner";
import StatsActiveRecurrentExpensesRow from "../StatsActiveRecurrentExpensesRow";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import toMoney from "../../../../../../utils";

export default function StatsRecurrentExpensesHistoryDialog({ token, open, onClose }) {

    const [history, setHistory] = useState([]);

    useEffect(() => {
        if (open) {
            SummaryAPI.get.getRecurrentExpensesHistory(token)
                .then(async response => {
                    const result = await response.json();
                    setHistory(result.data)
                })
        }
        else {
            const timeoutId = setTimeout(() => {
                setHistory([])
            }, 500)

            return () => {
                clearTimeout(timeoutId);
            }
        }
    }, [open])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen
        >
            <DialogTitle>
                <IconButton className='icon-size' onClick={onClose} ><ArrowBackIcon /></IconButton> Storico Spese Ricorrenti
            </DialogTitle>
            <DialogContent
                sx={{
                    background: "#4169e1bf",
                    paddingTop: "1vh !important"
                }}
            >
                {history.length === 0 && <div
                    style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <PennyPincherSpinner />
                </div>}
                {
                    history.length > 0 &&
                    <div
                        className="summary-money-in-total-container"
                        style={{
                            paddingBottom: "0.5vh"
                        }}
                    >
                        {history.map(expense => <StatsActiveRecurrentExpensesRow expense={expense} showTotalAmount={true} />)}
                    </div>
                }

            </DialogContent>
            <DialogActions>
                <div
                    className="summary-month-closing-descriptions"
                    style={{
                        fontSize: "5.5vw",
                        textAlign: "right",
                        padding: "1vh 0"
                    }}
                >
                    {history.length > 0 && <>Totale : {toMoney(history.reduce((sum, expense) => sum += expense.total_amount, 0))}</>}
                </div>
            </DialogActions>
        </Dialog>
    )
}